import type { IdOrigenPanel } from './geometriaTablero';

// D-08: assistant functions live under /assistant/<function>, with English slugs like the
// section segments. Action cards (NAV-07) and later phases link to these URLs, so a slug
// is a contract: rename it only together with every link that points at it.
export const SLUGS_FUNCION = Object.freeze([
    'clinical-document',
    'clinical-template',
    'chronology',
    'treatment-plan',
    'psychometry',
    'handwritten',
    'folders',
] as const);

export type SlugFuncion = (typeof SLUGS_FUNCION)[number];

export interface FuncionPanel {
    // AST-03: the card the work panel comes out of.
    readonly origen: IdOrigenPanel;
    // TOP-07: the last breadcrumb in state 3 names that card.
    readonly etiquetaMiga: string;
    readonly titulo: string;
}

// AST-03 table plus the E1 destinations (E2-E9). The chronology has no card of its own, so
// it comes out of the central card.
export const FUNCIONES_PANEL: Readonly<Record<SlugFuncion, FuncionPanel>> = Object.freeze({
    'clinical-document': { origen: 'documentos', etiquetaMiga: 'Documentos', titulo: 'Documento por secciones' },
    'clinical-template': { origen: 'documentos', etiquetaMiga: 'Documentos', titulo: 'Plantillas clínicas' },
    chronology: { origen: 'central', etiquetaMiga: 'Cronología del caso', titulo: 'Cronología del caso' },
    'treatment-plan': { origen: 'plan', etiquetaMiga: 'Plan de tratamiento', titulo: 'Plan terapéutico' },
    psychometry: { origen: 'documentos', etiquetaMiga: 'Documentos', titulo: 'Psicometría' },
    handwritten: { origen: 'documentos', etiquetaMiga: 'Documentos', titulo: 'Manuscritos' },
    folders: { origen: 'documentos', etiquetaMiga: 'Documentos', titulo: 'Carpetas, ayuda y correcciones' },
});

// T-07-01: the URL segment is user input. Object.hasOwn keeps inherited keys such as
// 'toString' or '__proto__' out of the allow-list.
export function esSlugFuncion(valor: string): valor is SlugFuncion {
    return Object.hasOwn(FUNCIONES_PANEL, valor);
}

export function rutaFuncion(pacienteId: string, slug: SlugFuncion): string {
    if (!pacienteId) throw new Error(`funcionesPanel: se necesita un pacienteId para abrir la función ${slug}`);
    return `/app/dashboard/patients/${encodeURIComponent(pacienteId)}/assistant/${slug}`;
}
